export const en = {
    banners: {
        one: '{count} ad',
        some: '{count} ads',
        many: '{count} ads',
        none: 'Ads'
    },
    'banners-loading-failed': 'Unable to upload ads',
    'go-to-banners': 'Go to ads in the group',
    'no-banners-available': 'No banners found for the keyword'
};
